<template>
<div class="chapter">
<div class="inner_page">
<h1 id="sigil_toc_id_4">Contents</h1>
<p class="veryfirst"><a href="#/Text/OutlineoftheBook.htm">Outline of the Book</a></p>
<p class="first"><a href="#/Text/Preface.htm">Preface</a></p>
<p class="first"><a href="#/Text/Introduction.htm">Introduction</a></p>
<p class="first"><a href="#/Text/PartI.htm"><strong class="b">Part I: The Bible and Mission</strong></a></p>
<div class="blockquote2">
<p class="left"><a href="#/Text/Ch01.htm"> 1 Searching for a Missional Hermeneutic</a></p>
<p class="left"><a href="#/Text/Ch02.htm"> 2 Shaping a Missional Hermeneutic</a></p>
</div>
<p class="first"><a href="#/Text/PartII.htm"><strong class="b">Part II: The God of Mission</strong></a></p>
<div class="blockquote2">
<p class="left"><a href="#/Text/Ch03.htm"> 3 The Living God Makes Himself Known in Israel</a></p>
<p class="left"><a href="#/Text/Ch04.htm"> 4 The Living God Makes Himself Known in Jesus Christ</a></p>
<p class="left"><a href="#/Text/Ch05.htm"> 5 The Living God Confronts Idolatry</a></p>
</div>
<p class="first"><a href="#/Text/PartIII.htm"><strong class="b">Part III: The People of Mission</strong></a></p>
<div class="blockquote2">
<p class="left"><a href="#/Text/Ch06.htm"> 6 God’s Elect People</a></p>
<p class="left"><a href="#/Text/Ch07.htm"> 7 God’s Particular People</a></p>
<p class="left"><a href="#/Text/Ch08.htm"> 8 God’s Model of Redemption</a></p>
<p class="left"><a href="#/Text/Ch09.htm"> 9 God’s Model of Restoration</a></p>
<p class="left"><a href="#/Text/Ch10.htm">10 The Span of God’s Missional Covenant</a></p>
<p class="left"><a href="#/Text/Ch11.htm">11 The Life of God’s Missional People</a></p>
</div>
<p class="first"><a href="#/Text/PartIV.htm"><strong class="b">Part IV: The Arena of Mission</strong></a></p>
<div class="blockquote2">
<p class="left"><a href="#/Text/Ch12.htm">12 Mission and God’s Earth</a></p>
<p class="left"><a href="#/Text/Ch13.htm">13 Mission and God’s Image</a></p>
<p class="left"><a href="#/Text/Ch14.htm">14 God and the Nations in Old Testament Vision</a></p>
<p class="left"><a href="#/Text/Ch15.htm">15 God and the Nations in New Testament Mission</a></p>
</div>
<p class="first"><a href="#/Text/Epilogue.htm">Epilogue</a></p>
<p class="first"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="first"><a href="#/Text/Bibliography.htm">Bibliography</a></p>
<p class="first"><a href="#/Text/nameindex.htm">Name Index</a></p>
<p class="first"><a href="#/Text/subjectindex.htm">Subject Index</a></p>
<p class="first"><a href="#/Text/scriptureindex.htm">Scripture Index</a></p>
<p class="first"><a href="#/Text/Langhampage.htm">Langham Literature</a></p>
<p class="first"><span href="#/Text/praisefor" title="Link target outside of Sample">Praise for <em>The Mission of God</em></span></p>
<p class="first"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="first"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?18955958